module.exports = __webpack_public_path__ + "static/media/budget.17e64dc3.png";